/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Calendar_Day_TodayInputs */

const fr_calendar_day_today = /** @type {(inputs: Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aujourd’hui, ${i?.date}`)
};

const en_calendar_day_today = /** @type {(inputs: Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Today, ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Today, {date}" |
*
* @param {Calendar_Day_TodayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_day_today = /** @type {((inputs: Calendar_Day_TodayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Day_TodayInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_day_today(inputs)
	return fr_calendar_day_today(inputs)
});